import React from 'react';

import {LeadsTableHeaders} from "./LeadsTableHeaders";
import {LeadItem} from "./LeadItem";
import CustomInfiniteScroll from "../../../components/CustomInfiniteScroll";
import {useLeadsStore} from "../../../stores/leadsStore";
import { useShallow } from 'zustand/react/shallow'
import {useCRMStore} from "../../../stores/crmStore";


export const LeadsTable = () => {
    const { currentYear, currentMonth, search } = useCRMStore(
        useShallow((state) => ({
            currentYear: state.currentYear,
            currentMonth: state.currentMonth,
            search: state.search,
        }))
    )

    const {
        leads,
        current_page,
        has_more,
        fetchListLeads,
        shouldFetchNextLeads,
    } = useLeadsStore(
        useShallow((state) => ({
            leads: state.leads,
            fetchListLeads: state.fetchListLeads,
            shouldFetchNextLeads: state.shouldFetchNextLeads,
            current_page: state.current_page,
            has_more: state.has_more,
            removeDeletedLeadFromList: state.removeDeletedLeadFromList,
            addCreatedLeadToList: state.addCreatedLeadToList,
        }))
    )

    const buildParams = (current_page) => {
        let queryParams = new URLSearchParams({
            month: currentMonth,
            year: currentYear
        })

        if (typeof current_page === 'number' && current_page !== 0) {
            queryParams.append("page", current_page + 1)
        }

        if (search.length) {
            queryParams.append("s", search)
        }
        return queryParams
    }

    return (
        <div className={'parent-scroll-ref'} id={"LeadsTableParentScrollRef"}>
            <table className={'LeadsTable'}>
                <LeadsTableHeaders/>
                <CustomInfiniteScroll
                    initialLoad={false}
                    useWindow={false}
                    pageStart={current_page}
                    loadMore={(page) => {
                        if (shouldFetchNextLeads()) {
                            fetchListLeads(buildParams(current_page))
                        }
                    }}
                    hasMore={has_more}
                    element={'tbody'}
                    className={'LeadsTable-container'}
                    getScrollParent={() => document.getElementById("LeadsTableParentScrollRef")}
                >
                    {leads.map((lead, idx) => (
                        <LeadItem key={lead.id} lead={lead}/>
                    ))}
                </CustomInfiniteScroll>
            </table>
        </div>
    )
}